import { useState } from 'react';

export default (state) => {
  const [isVisible, setVisibility] = useState(state);

  const toggleVisibility = () => setVisibility(!isVisible);

  return [isVisible, toggleVisibility];
};
